import { Component, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { EmpresasService } from '../../../services/empresa/empresas.service';
import { SnackbarService } from '../../../services/snackbar/snackbar.service';
import { AuthService } from '../../../services/auth/auth.service';
import { SelecionarEnderecoModal } from '../../../modals/selecionar-endereco-modal/selecionar-endereco-modal';
import { SelecionarEmpresaModal } from '../../../modals/selecionar-empresa-modal/selecionar-empresa-modal';
import { DesvincularEmpresa } from '../cadastrar-pessoa/dialogs/desvincular-empresa/desvincular-empresa';
import { DesvincularEndereco } from '../cadastrar-pessoa/dialogs/desvincular-endereco/desvincular-endereco';
import { UsuarioDetalhado } from '../../../models/UsuarioDetalhado';
import { UsuariosService } from '../../../services/usuario/usuarios.service';
import { ImportacaoService } from '../../../services/importacao/importacao-service';
import { MatExpansionModule } from '@angular/material/expansion';
import { ResultadoImportacao } from '../../../dto/importacao/ImportacaoDTO';

@Component({
  selector: 'app-importar-pessoas',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatCardModule,
    MatDialogModule,
    MatExpansionModule,
    MatTableModule,
    MatChipsModule,
  ],
  templateUrl: './importar-pessoas.html',
  styleUrl: './importar-pessoas.scss',
})
export class ImportarPessoas implements OnInit {
  arquivoSelecionado = signal<File | null>(null);

  // Estados do processo
  processando = false;
  progresso = 0;
  resultadoImportacao: ResultadoImportacao | null = null;

  // Listas de opções (viriam de um service)
  empresaSelecionada: any = null;
  enderecoSelecionado: any = null;
  empresasOptions: any[] = [];

  touchedEmpresa = false;
  empresaDummyModel = '';

  touchedEndereco = false;
  enderecoDummyModel = '';
  touchedArquivo = false;

  // Colunas da tabela de erros
  displayedColumns: string[] = ['linha', 'erro', 'tipo'];
  usuarioId: number | null = null;

  modoEdicao = false;
  formBloqueado = signal(false);

  constructor(
    private dialog: MatDialog,
    private readonly empresaService: EmpresasService,
    private readonly snackbarService: SnackbarService,
    private readonly usuarioService: UsuariosService,
    private readonly importacaoService: ImportacaoService,
    private readonly authService: AuthService,
  ) {}

  async ngOnInit() {
    await this.buscaEmpresaVinculada();
    await this.atualizarDadosEmpresaEEnderecoBaseadoNaPessoa();

    if (this.modoEdicao) {
      this.formBloqueado.set(false);
    }
  }

  async atualizarDadosEmpresaEEnderecoBaseadoNaPessoa() {
    this.usuarioId = this.authService.getUsuarioId();
    if (this.usuarioId == null) {
      console.log(
        'Usuário não autenticado. Não é possível buscar dados de empresa e endereço.',
      );
      return;
    }

    const u = await this.usuarioService.buscarUsuarioPorId(this.usuarioId);

    ((this.empresaSelecionada = this.empresasOptions.find(
      (e: any) => e.idEmpresa == u.empresaResumo.id,
    )),
      console.log(this.empresaSelecionada));
    this.enderecoSelecionado = this.empresaSelecionada.enderecos.find(
      (e: any) => e.id == this.empresaSelecionada.enderecos.idEstabelecimento,
    );
  }

  abrirDesvincularEmpresa() {
    const dialogRef = this.dialog.open(DesvincularEmpresa, {
      width: '400px',
      data: {
        empresa: this.empresaSelecionada,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.removeEmpresaSelecionada();
        this.snackbarService.success('Empresa desvinculada com sucesso!');
      }
    });
  }

  abrirDesvincularEndereco() {
    const dialogRef = this.dialog.open(DesvincularEndereco, {
      width: '500px',
      data: {
        empresaSelecionada: this.empresaSelecionada,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === true) {
        this.removeEnderecoSelecionado();
        this.snackbarService.success('Endereço desvinculado com sucesso');
      }
    });
  }

  abrirModalEmpresas() {
    this.touchedEmpresa = true;
    const dialogRef = this.dialog.open(SelecionarEmpresaModal, {
      data: {
        empresas: this.empresasOptions,
        empresaSelecionada: this.empresaSelecionada,
      },
    });
    dialogRef.afterClosed().subscribe((empresa: any) => {
      if (empresa) this.empresaSelecionada = empresa;
    });
  }

  removeEmpresaSelecionada() {
    this.empresaSelecionada = null;
    this.enderecoSelecionado = null;
  }

  abrirModalEnderecos() {
    this.touchedEndereco = true;
    const dialogRef = this.dialog.open(SelecionarEnderecoModal, {
      data: {
        empresas: this.empresasOptions,
        empresaSelecionada: this.empresaSelecionada,
        enderecoSelecionado: this.enderecoSelecionado,
      },
    });

    dialogRef.afterClosed().subscribe((endereco: any) => {
      if (endereco) this.enderecoSelecionado = endereco;
    });
  }

  removeEnderecoSelecionado() {
    this.enderecoSelecionado = null;
  }

  onTouchedAll() {
    this.touchedEmpresa = true;
    this.touchedEndereco = true;
  }

  async buscaEmpresaVinculada() {
    try {
      this.empresasOptions =
        await this.empresaService.consultaTelaVincularEmpresaAPessoa();
    } catch (err: any) {
      this.snackbarService.error('Erro ao buscar as empresas');
    }
  }

  /**
   * Chamado quando uma empresa é selecionada
   */
  onEmpresaSelecionada(empresaId: number): void {
    const empresa = this.empresasOptions.find((e) => e.id === empresaId);
    this.empresaSelecionada = empresa || null;
    this.touchedEmpresa = true;

    // Limpar endereço ao trocar empresa
    if (this.enderecoSelecionado) {
      this.enderecoSelecionado = null;
      this.touchedEndereco = false;
    }

    // Carregar endereços da empresa selecionada
  }

  /**
   * Chamado quando um endereço é selecionado
   */
  onEnderecoSelecionado(enderecoId: number): void {
    const endereco = this.empresasOptions.find((e) => e.id === enderecoId);
    this.enderecoSelecionado = endereco || null;
    this.touchedEndereco = true;
  }

  /**
   * Desvincular empresa selecionada
   */
  desvincularEmpresa(): void {
    this.empresaSelecionada = null;
    this.enderecoSelecionado = null;
    this.touchedEmpresa = false;
    this.touchedEndereco = false;
  }

  /**
   * Desvincular endereço selecionado
   */
  desvincularEndereco(): void {
    this.enderecoSelecionado = null;
    this.touchedEndereco = false;
  }

  /**
   * Abre o seletor de arquivo
   */
  abrirSeletorArquivo(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  /**
   * Chamado quando o usuário seleciona um arquivo
   */
  onArquivoSelecionado(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const arquivo = input.files[0];

      if (!this.validarTipoArquivo(arquivo)) {
        this.snackbarService.error(
          'Por favor, selecione um arquivo Excel (.xlsx ou .xls)',
        );
        input.value = '';
        return;
      }

      if (!this.validarTamanhoArquivo(arquivo, 10)) {
        this.snackbarService.error('O arquivo deve ter no máximo 10MB');
        input.value = '';
        return;
      }

      this.arquivoSelecionado.set(arquivo);
      this.touchedArquivo = true;
      this.resultadoImportacao = null;
    }
  }

  /**
   * Valida se o arquivo é do tipo Excel
   */
  validarTipoArquivo(arquivo: File): boolean {
    const tiposPermitidos = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel', // .xls
    ];

    return (
      tiposPermitidos.includes(arquivo.type) ||
      arquivo.name.endsWith('.xlsx') ||
      arquivo.name.endsWith('.xls')
    );
  }

  /**
   * Valida o tamanho do arquivo em MB
   */
  validarTamanhoArquivo(arquivo: File, maxMB: number): boolean {
    const maxBytes = maxMB * 1024 * 1024;
    return arquivo.size <= maxBytes;
  }

  /**
   * Remove o arquivo selecionado
   */
  removerArquivo(): void {
    this.arquivoSelecionado.set(null);
    this.touchedArquivo = false;
    this.resultadoImportacao = null;

    // Limpar o input file
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  /**
   * Valida se todos os campos obrigatórios estão preenchidos
   */
  formularioValido(): boolean {
    return !!(
      this.empresaSelecionada &&
      this.enderecoSelecionado &&
      this.arquivoSelecionado()
    );
  }

  /**
   * Marca todos os campos como tocados (para mostrar erros)
   */
  marcarTodosCamposTocados(): void {
    this.touchedEmpresa = true;
    this.touchedEndereco = true;
    this.touchedArquivo = true;
  }

  /**
   * Formata o tamanho do arquivo para exibição
   */
  formatarTamanhoArquivo(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }

  /**
   * Formata o status para exibição (substitui underscores por espaços)
   */
  formatarStatus(status: string): string {
    return status.replace(/_/g, ' ');
  }

  /**
   * Baixar planilha modelo
   */
  baixarPlanilhaModelo(): void {
    const link = document.createElement('a');
    link.href = 'assets/xlsx/Planilha modelo.xlsx';
    link.download = 'Planilha modelo.xlsx';
    link.target = '_blank';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  /**
   * Processa a importação do arquivo
   */
  async processarImportacao(): Promise<void> {
    if (!this.formularioValido()) {
      this.marcarTodosCamposTocados();
      return;
    }

    this.processando = true;
    this.progresso = 0;
    this.resultadoImportacao = null;

    try {
      const formData = new FormData();
      formData.append('file', this.arquivoSelecionado()!);
      formData.append('empresaId', this.empresaSelecionada!.idEmpresa);
      formData.append(
        'enderecoId',
        this.enderecoSelecionado!.idEstabelecimento,
      );

      const resultado = await this.importacaoService.importarPessoas(formData);
      this.resultadoImportacao = resultado as ResultadoImportacao;
      console.log(this.resultadoImportacao);
      this.formBloqueado.set(true);
    } catch (error: any) {
      this.snackbarService.error(
        error.message || 'Erro ao processar a importação',
      );
    } finally {
      this.processando = false;
    }
  }

  /**
   * Baixar relatório de erros
   */
  async baixarRelatorioErros(): Promise<void> {
    await this.importacaoService.baixarRelatorio(
      this.resultadoImportacao!.importacaoId,
    );
  }

  /**
   * Cancelar e voltar
   */
  cancelar(): void {
    if (
      confirm('Deseja realmente cancelar? Todas as alterações serão perdidas.')
    ) {
      this.limparFormulario();
      this.formBloqueado.set(false);
    }
  }

  /**
   * Limpa todo o formulário
   */
  limparFormulario(): void {
    this.empresaSelecionada = null;
    this.enderecoSelecionado = null;
    this.arquivoSelecionado.set(null);
    this.touchedEmpresa = false;
    this.touchedEndereco = false;
    this.touchedArquivo = false;
    this.processando = false;
    this.progresso = 0;
    this.resultadoImportacao = null;

    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  /**
   * Reiniciar importação (após visualizar resultados)
   */
  novaImportacao(): void {
    this.limparFormulario();
    this.formBloqueado.set(false);
  }
}
